/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ExposureIcon = ({ width = 24, height = 24, hidden = false, title = 'Exposure' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m10,1.2793C5.1748,1.2793,1.25,5.2041,1.25,10.0293s3.9248,8.75,8.75,8.75,8.75-3.9248,8.75-8.75S14.8252,1.2793,10,1.2793Zm7.25,8.75c0,.23975-.01306.47656-.03589.71069l-5.91797-4.29883,3.03821-2.20996c1.76587,1.32349,2.91565,3.42627,2.91565,5.7981Zm-5.56201,2.4707h-3.34326l-1.02368-3.16748,2.70056-1.96436,2.70642,1.96582-1.04004,3.16602Zm1.23743-9.09912l-6.08972,4.42969-1.16455-3.60352c1.20972-.90479,2.70508-1.44775,4.32886-1.44775,1.04126,0,2.02954.22461,2.92542.62158Zm-8.46448,1.96045l2.30701,7.13867h-3.5752c-.28137-.77246-.44275-1.60205-.44275-2.4707,0-1.77783.64539-3.40576,1.71094-4.66797Zm-.52002,8.63867h7.25439l-1.0752,3.27319c-.04041.00073-.07959.0061-.12012.0061-2.53223,0-4.76208-1.30688-6.05908-3.2793Zm7.83191,3.05103l2.23059-6.79028,2.86255,2.0791c-.78174,2.31641-2.70142,4.10693-5.09314,4.71118Z"
      fill="currentColor"
    />
  </svg>`;
};
